<template>
  <div class="gameplay_footer footer_fixed">
    <p>{{ getTranslations.home_game_footer }}</p>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters } from 'vuex';

export default {
  name: 'gameFooter',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/GameFooter.vue